import { NotificationManagement } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// NotificationManagementServices contains functions to interact with notification-related APIs for the admin module.
// Each function corresponds to a specific API endpoint for tasks such as sending notifications, etc.
export const NotificationManagementServices = {
  /**
   * Function for user login.
   * @param {Object} values - User login credentials.
   * @returns {Promise<Object>} - A promise that resolves to the response from the login API.
   */
  sendNotification: async (bodyData) => {
    try {
      const payload = {
        ...NotificationManagement.sendNotification,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for user login.
   * @param {Object} values - User login credentials.
   * @returns {Promise<Object>} - A promise that resolves to the response from the login API.
   */
  getNotificationService: async (bodyData) => {
    try {
      const payload = {
        ...NotificationManagement.sendNotification,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
